import React, { FC, useState } from 'react'

import { SlimProgressTimer } from '@Components/CMS/Bar/BarFactory/Bars/Urgency/SlimUrgencyBar/SlimProgressTimer'
import { MarketingEvents } from '@Components/CMS/Bar/BarFactory/Bars/Urgency/TallUrgencyBar/UrgencyBarHelpers'
import { BarProps } from '@Components/CMS/Bar/BarFactory/types'
import { useRTEField } from '@Globals/CMS/FieldHelpers'
import { formatTimer } from '@Globals/TimeHelpers'

import styles from './SlimUrgencyBar.module.scss'

export const SlimUrgencyBar: FC<BarProps> = ({ bar, order }) => {
  const [timer, setTimer] = useState('00:00:00')
  const { fields, urgencyTimerDateEnd, urgencyTimerDateStart } = bar
  const mobileRTEField = useRTEField(fields, 'textMobile')
  const leftRTEField = useRTEField(fields, 'textLeft')
  const rightRTEField = useRTEField(fields, 'textRight')

  return (
    <div className={styles.container} style={{ background: bar.backgroundColor, color: bar.textColor, order }}>
      <div className={`${styles.content} ${styles.mobile}`} dangerouslySetInnerHTML={{ __html: mobileRTEField || '' }} />
      <div className={`${styles.content} ${styles.desktop}`}>
        {leftRTEField && (<span className={styles.text} dangerouslySetInnerHTML={{ __html: leftRTEField }} />)}
        {rightRTEField && (<span className={styles.text} dangerouslySetInnerHTML={{ __html: rightRTEField }} />)}
      </div>
      <div className={styles.timer}>{timer}</div>
      <SlimProgressTimer
        className={styles.progress}
        config={{
          type: MarketingEvents.FREE_SHIPPING,
          range: { to: new Date(urgencyTimerDateEnd!), from: new Date(urgencyTimerDateStart!) },
        }}
        fixed={1}
        hourlyReset={bar.addons?.includes('reset-urgency-timer-hourly')}
        progressColor={bar.textColor}
        startAtFifty={bar.addons?.includes('start-urgency-timer-at-50')}
        timeUpdated={({ hours, minutes, seconds }) => setTimer(`${formatTimer(hours)}:${formatTimer(minutes)}:${formatTimer(seconds)}`)}
      />
    </div>
  )
}

export default SlimUrgencyBar
